import { BankTypeEnum, FiservCardInterface, FiservCardStatusEnum, OptionKey } from '@common-fe/common-fe';

export enum CardReplacementReasons {
  LOST = 'Card lost',
  STOLEN = 'Card stolen',
  NOT_RECEIVED = 'Card not received',
  DAMAGED = 'Damaged',
  DEMOGRAPHIC_CHANGE = 'Demographic change',
}

export enum CloseActionCardType {
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY',
}

export enum ReplacementInitiationType {
  BANNER = 'BANNER',
  CARDS_PAGE = 'CARDS_PAGE',
  ADMIN_PORTAL = 'ADMIN_PORTAL',
}

export const ReplacementInitiationTypeTitle = {
  [ReplacementInitiationType.BANNER]: 'Card activation banner',
  [ReplacementInitiationType.CARDS_PAGE]: 'Cards page',
  [ReplacementInitiationType.ADMIN_PORTAL]: 'Admin portal',
};

export interface ChangeCardStatusMutationArgs {
  id: string;
  status: FiservCardStatusEnum;
  isEmployeeUnlockForbidden?: boolean;
  lockedPursesIds?: string[];
  lockReason?: OptionKey;
}

export enum CardHolderType {
  PRIMARY = 'PRIMARY',
}

export interface CardsMap {
  [holderName: string]: {
    [cardStatus in FiservCardStatusEnum]: FiservCardInterface[];
  };
}

export enum CardActivationModalType {
  Activation = 'Activation',
  Processing = 'Processing',
  Error = 'Error',
}

export interface FiservCardPurseDto {
  id: number;
  account_name: string;
  account_type: string;
  status: string;
  is_locked_by_health_plan?: boolean | null;
}

export interface CardResponse {
  description: string;
  id: number;
  last4?: string;
  last2?: string;
  opened_on: Date;
  mailed_on_date: string;
  mailed_on: Date;
  activated_on: Date;
  expires_on_date: string;
  pin_set: boolean;
  created_at: Date;
  modified_at: Date;
  card_status: FiservCardStatusEnum;
  card_type: BankTypeEnum;
  sequence_number: number | null;
  card_account_id: number;
  account_ids: number[];
  member_sequence_identifier: number;
  alternate_account_id: string;
  employee_unlock_forbidden: boolean;
  token_card_id?: string;
  fraud_confirmed?: boolean;
  fraud_confirmed_date?: Date;
}

export interface CardHoldersResponse {
  suffix: string;
  dependents: CardHoldersResponse[];
  id: number;
  preferred_name: string;
  middle_name: string;
  first_name: string;
  last_name: string;
  date_of_birth: string;
  relationship: string;
  employee_id: number;
  person_id: number;
  dependent_id: null | number;
  card_holder_type: string;
  card_holder_status: string;
  grouped_cards?: {
    [cardStatus in FiservCardStatusEnum]: CardResponse[];
  };
}

export interface SearchTransactionParams {
  categories?: string;
  statuses?: string;
  provider?: string;
  status_date_from?: string | null;
  status_date_to?: string | null;
  accountTypes?: string;
  years?: string;
  page?: number;

  size?: number;
  employee_id?: number;
}
